<template>
    <div id="app">
        <nav class="navbar is-transparent">
            <div class="navbar-brand">
                <a class="navbar-item" href="https://www.gramme.tech">
                    <img src="/img/logo.png" :style="{height:40+'px'}">
                </a>
                <div class="navbar-burger burger" data-target="navbarExampleTransparentExample">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>

            <div id="navbarExampleTransparentExample" class="navbar-menu">
                <div class="navbar-start">            
                </div>

                <div class="navbar-end">
                    <div class="navbar-item">
                        <div class="field is-grouped">
                            <p class="control">
                                <a class="button is-dark" href="https://www.gramme.tech/contact">           
                                    <span>
                                        Contactez-nous
                                    </span>
                                </a>
                            </p>
                            <p class="control">
                                <a class="button is-dark" href="https://www.gramme.tech/base-de-connaissance">
                                    <span>Vers la base de connaissance</span>
                                </a>
                            </p>
                            <p class="control">
                                <a class="button is-primary" href="https://www.gramme.tech">
                                    <span>Retour au site</span>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <div class="container">
            <div class="section">

                <div class="animated fadeInDown content has-text-centered" :style="{animationDelay:200+'ms'}">
                    <h1 class="is-title is-uppercase"><span class="has-text-primary">Simuler</span> votre installation</h1>
                    <p class="has-text-justify">
                        <p>La simulation de votre installation répond à des principes trigonométriques associés à des données d’ensoleillement connues. Sa rentabilité est liée aux dispositions légales en vigueur ainsi qu’à son prix.</p>
                        <p>Ce dernier point et les considérations complémentaires qu’il implique nécessitent la tenue d’une rencontre à votre habitation, commerce ou entreprise.</p>
                        <p>Plus d’informations disponibles à la page « Le Photovoltaïque »</p>

                    </p>
                </div>
                <div class="animated fadeInDown content has-text-centered" :style="{animationDelay:0+'ms'}">
                    <h1 class="is-title is-uppercase"><span class="has-text-primary">Dimensionnement</span> de votre installation</h1>
                </div>
            </div>
            <div class="section">
                <div class="columns">
                    <div class="column is-6">
                        <div class="card animated fadeIn" :style="{animationDelay:200+'ms'}">
                            <header class="card-header">
                                <p class="card-header-title is-uppercase">
                                    Votre type d'implantation 
                                </p>
                            </header>
                            <div class="card-content">
                                <div class="content">
                                    <label class="label">
                                        Implantation
                                        <b-tooltip multilined class="card-header-icon" label="La nature du revêtement influence la structure de pose de vos modules, leur calage angulaire et la surface utile nécessaire." position="is-right">
                                            <button class="button is-small is-light">
                                                <b-icon :icon="'question'" :size="'is-small'"/>
                                            </button>
                                        </b-tooltip>
                                    </label>
                                    <div class="columns">
                                        <div class="column is-3 has-text-centered" v-for="(r,i) in roofs">

                                            <div class="control">
                                                <label tabindex="0" :class="{'is-primary':roof === i}" class="b-radio radio button is-outlined is-large">
                                                    <img :src="r.icon" alt="">
                                                    <input v-model="roof" :value="i" type="radio" value="0">
                                                </label>
                                            </div>
                                            <p class="control has-text-centered">{{r.name}}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <label class="label">
                                        Âge de votre bâtiment
                                        <b-tooltip multilined class="card-header-icon" label="Si votre bâtiment a moins de 10 ans, la TVA sur les travaux est de 21% ; si plus de 10 ans, elle est de 6%." position="is-right">
                                            <button class="button is-small is-light">
                                                <b-icon :icon="'question'" :size="'is-small'"/>
                                            </button>
                                        </b-tooltip>                                    
                                    </label>

                                    <div class="columns">
                                        <div class="column is-6 has-text-centered" v-for="(a,i) in ages">
                                            <div class="control">
                                                <label tabindex="0" :class="{'is-primary':age === i}" class="b-radio radio button is-outlined is-large">
                                                    {{a}}
                                                    <input v-model="age" :value="i" type="radio" value="0">
                                                </label>
                                            </div>
                                        </div>
                                    </div>                                 
                                </div>
                            </div>
                        </div>
                        <div class="card animated fadeIn" :style="{animationDelay:600+'ms'}">
                            <header class="card-header">
                                <p class="card-header-title is-uppercase">
                                    Inclinaison 
                                </p>
                                 <b-tooltip multilined class="card-header-icon" label="La combinaison « inclinaison/orientation » des panneaux influence votre productivité. En toiture plate cette dernière est a priori figée à 15°. Avec un tracker, elle peut varier en fonction de l’heure de la journée." position="is-left">
                                    <button class="button is-small is-light">
                                        <b-icon :icon="'question'" :size="'is-small'"/>
                                    </button>
                                </b-tooltip>
                            </header>
                            <div class="card-content">
                                <div class="content">

                                    <div :style="{
                                        position:'relative',
                                        overflow: 'hidden',
                                        lineHeight: 0,
                                        marginBottom: 30+'px'
                                    }">
                                        <img src="/img/tilt-bg.svg" :style="{width:50+'%', marginLeft: 25+'%',}">
                                        <img src="/img/tilt-fg.svg"
                                            :style="{
                                                width:50+'%',
                                                marginLeft: 25+'%',
                                                top: 0,
                                                left: 0,
                                                position: 'absolute',
                                                transition: 'transform 1200ms cubic-bezier(.87,-.41,.19,1.44)',
                                                transformOrigin: 'bottom right',
                                                transform: 'rotate('+(parseInt(tilt) - 90)+'deg)'
                                            }"
                                        >
                                        <h2 class="is-title has-text-primary has-text-centered" :style="{
                                            position: 'absolute',
                                            top: 40+'%',
                                            width: 100+'%',
                                        }">
                                            {{parseInt(tilt)}}°
                                        </h2>
                                    </div>   


                                    <vue-slider
                                        :disabled="roof != 0"
                                        v-model="tilt"
                                        :data="tilts"
                                        :tooltip="false"
                                    >
                                        
                                    </vue-slider>
                                    <div class="columns is-mobile">                                                                            
                                        <div class="column has-text-left">0°</div>
                                        <div class="column has-text-centered">15°</div>
                                        <div class="column has-text-centered">25°</div>
                                        <div class="column has-text-centered">35°</div>
                                        <div class="column has-text-centered">50°</div>
                                        <div class="column has-text-centered">70°</div>
                                        <div class="column has-text-right">90°</div>
                                    </div>                                    
                                </div>
                            </div>
                        </div>    
                        <div class="card animated fadeIn" :style="{animationDelay:1000+'ms'}">
                            <header class="card-header">
                                <p class="card-header-title is-uppercase">
                                    Votre région
                                </p>
                                 <b-tooltip multilined class="card-header-icon" label="Les dispositions légales en vigueur dans votre région influencent la rentabilité de votre installation." position="is-left">
                                    <button class="button is-small is-light">
                                        <b-icon :icon="'question'" :size="'is-small'"/>
                                    </button>
                                </b-tooltip>
                            </header>
                            <div class="card-content">
                                <div class="content">
                                    <b-field>                                        
                                        <b-input type="number" maxlength="4" expanded v-model="postalCode"></b-input>                                    
                                    </b-field>
                                    <p class="control">
                                        Votre gestionnaire de réseau est : <strong v-if="grd">{{grd.name}}</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card animated fadeIn" :style="{animationDelay:1400+'ms'}">
                            <header class="card-header">
                                <p class="card-header-title is-uppercase">
                                    Inflation
                                </p>
                                 <b-tooltip multilined class="card-header-icon" label="L’augmentation générale du prix de l’électricité en Europe est particulièrement fluctuante, et incertaine en Belgique. Sur les 10 dernières années, son niveau moyen dépasse les 3%." position="is-left">
                                    <button class="button is-small is-light">
                                        <b-icon :icon="'question'" :size="'is-small'"/>
                                    </button>
                                </b-tooltip>
                            </header>
                            <div class="card-content">
                                <div class="content">
                                    <h2 class="is-title has-text-primary has-text-centered">
                                        {{inflation}} %/an
                                    </h2>                                    
                                    <vue-slider
                                       v-model="inflation"
                                        :min="2"
                                        :max="4"
                                        :interval="0.01"   
                                        :formatter="(v) => v+'%'"
                                        :tooltip="false"
                                    ></vue-slider>
                                   <div class="columns is-mobile has-text-centered">                                    
                                        <div class="column has-text-left">2%</div>                                        
                                        <div class="column has-text-right">4%</div>
                                    </div>                                    
                                </div>
                            </div>
                        </div>  
                    </div>

                    <div class="column is-6">
                        <div class="card animated fadeIn" :style="{animationDelay:400+'ms'}">
                            <header class="card-header">
                                <p class="card-header-title is-uppercase">
                                    Orientation
                                </p>
                                 <b-tooltip multilined class="card-header-icon" label="La combinaison « inclinaison/orientation » des panneaux influence votre productivité. Avec un tracker elle peut varier en fonction de l’heure de la journée." position="is-left">
                                    <button class="button is-small is-light">
                                        <b-icon :icon="'question'" :size="'is-small'"/>
                                    </button>
                                </b-tooltip>
                            </header>
                            <div class="card-content">
                                <div class="content">
                 
                                    
                                    <div :style="{
                                        position:'relative',
                                        lineHeight: 0,
                                    }">
                                        <img src="/img/orientation-bg.svg" :style="{width:100+'%'}">
                                        <img src="/img/orientation-fg.svg"
                                            :style="{
                                                width:100+'%',
                                                top: 0,
                                                left: 0,
                                                position: 'absolute',
                                                transformOrigin: 'center',
                                                transition: 'transform 800ms cubic-bezier(.87,-.41,.19,1.44)',
                                                transform: 'rotate('+(- parseInt(orientation) + 180)+'deg)'
                                            }"
                                        >
                                        <h2 class="title has-text-primary has-text-centered" :style="{
                                            position: 'absolute',
                                            top: 40+'%',
                                            width: 100+'%',
                                        }">
                                            {{180 - parseInt(orientation)}}°
                                        </h2>
                                    </div>                             
                                     <vue-slider 
                                        v-model="orientation"
                                        :data="orientations"
                                        :tooltip="false"
                                        :disabled="roof == 1"                                        
                                    >                              
                                    </vue-slider>
                                    <div class="columns is-mobile has-text-centered">                                    
                                        <div class="column is-2 has-text-left">+90° <br>(ouest)</div>
                                        <div class="column is-2">+45° <br>(sud-ouest)</div>
                                        <div class="column is-4">0° <br>(sud)</div>
                                        <div class="column is-2">-45° <br>(sud-est)</div>
                                        <div class="column is-2 has-text-right">-90° <br>(est)</div>
                                    </div>
                                </div>
                            </div>
                        </div>                  

                

                        <div class="card animated fadeIn" :style="{animationDelay:800+'ms'}">
                            <header class="card-header">
                                <p class="card-header-title is-uppercase">
                                    Votre consommation 
                                </p>
                                 <b-tooltip multilined class="card-header-icon" label="Votre consommation, exprimée en kWh, selon un régime mono ou bi-horaire, se situe sur la facture de décompte annuelle transmise par votre fournisseur d’électricité." position="is-left">
                                    <button class="button is-small is-light">
                                        <b-icon :icon="'question'" :size="'is-small'"/>
                                    </button>
                                </b-tooltip>
                            </header>
                            <div class="card-content">
                                <div class="content"> 


                                    <template v-if=" ! unkownConsumtion">
                                        <label class="label">Votre consommation</label>
                                        <h2 class="is-title has-text-primary has-text-centered">
                                            {{consumption}} kWh/an
                                        </h2>                                                       
                                        
                                        <vue-slider
                                            v-model="consumption"
                                            :min="1000"
                                            :max="10000"
                                            :interval="100"   
                                            :formatter="(v) => v+'kWh/an'"
                                            :tooltip="false"
                                            :piecewise="false"
                                            :piecewiseLabel="true"                                            
                                        >             
                                            <template slot="label" scope="{ label, active }">
                                              <span v-if="label % 10 === 0">
                                                {{ label }}
                                              </span>
                                            </template>                                                               
                                        </vue-slider>
                                        <div class="columns is-mobile has-text-centered">                                    
                                            <div class="column has-text-left">1000</div>
                                            <div class="column">2000</div>
                                            <div class="column">3000</div>
                                            <div class="column">4000</div>
                                            <div class="column">5000</div>
                                            <div class="column">6000</div>
                                            <div class="column">7000</div>
                                            <div class="column">8000</div>
                                            <div class="column">9000</div>
                                            <div class="column has-text-right">10000</div>
                                        </div>      
                                        <hr>                              
                                        <a @click="unkownConsumtion = true">Je ne connais pas ma consommation</a>
                                    </template>
                                    <template v-else>
                                        
                                        <label class="label">Nombre d'habitants</label>
                                        <b-select expanded v-model="consumption">
                                            <option v-for="(u,i) in consumptions" :value="u">{{i + 1}} ({{u}} kWh/an)</option>
                                        </b-select>
                                        <hr>
                                        <a @click="unkownConsumtion = false">Je connais ma consommation</a>
                                    </template>
                                </div>
                            </div>
                        </div>                 



                        <div class="card animated fadeIn" :style="{animationDelay:1200+'ms'}">
                            <header class="card-header">
                                <p class="card-header-title is-uppercase">
                                    Prix de l'électricité 
                                </p>
                                 <b-tooltip multilined class="card-header-icon" label="Variable en fonction de votre région et volume de consommation, le prix moyen de l’électricité résidentielle est de 0,25€/kWh. Pour connaître votre tarif, il vous faut diviser le montant de votre facture annuelle (TVAC) par le nombre de kWh qui lui est associé." position="is-left">
                                    <button class="button is-small is-light">
                                        <b-icon :icon="'question'" :size="'is-small'"/>
                                    </button>
                                </b-tooltip>
                            </header>
                            <div class="card-content">
                                <div class="content">
                                    <h2 class="is-title has-text-primary has-text-centered">
                                        {{electricityPrice}} €/kWh
                                    </h2>
                                    <vue-slider
                                        v-model="electricityPrice"
                                        :min="0.1"
                                        :max="0.4"
                                        :interval="0.01"
                                        :formatter="(v) => v+'€/kWh'"
                                        :tooltip="false"                                         
                                    >             
                                        
                                    </vue-slider>
                                   <div class="columns is-mobile has-text-centered">                                    
                                        <div class="column has-text-left">0,10€</div>
                                        <div class="column">0,15€</div>
                                        <div class="column">0,20€</div>
                                        <div class="column">0,25€</div>
                                        <div class="column">0,30€</div>
                                        <div class="column">0,35€</div>
                                        <div class="column has-text-right">0,40€</div>
                                    </div>                                    
                                </div>
                            </div>
                        </div>               
   

                    
                        <div class="card animated fadeIn" :style="{animationDelay:1600+'ms'}">
                            <header class="card-header">

                                <p class="card-header-title is-uppercase">
                                    Autoconsommation
                                </p>
                                 <b-tooltip multilined class="card-header-icon" label="D’ici quelques années, vous aurez la possibilité d’influencer la rentabilité de votre installation en augmentant votre niveau d’autoconsommation. La moyenne belge actuelle se situe à 37%." position="is-left">
                                    <button class="button is-small is-light">
                                        <b-icon :icon="'question'" :size="'is-small'"/>
                                    </button>
                                </b-tooltip>
                            </header>
                            <div class="card-content">
                                <div class="content">
                                    <h2 class="is-title has-text-success has-text-centered">
                                        {{autoconsumption}} %
                                    </h2>                                            
                                    <vue-slider v-model="autoconsumption"
                                        
                                        :processStyle="{backgroundColor:'#23d160'}"
                                        :min="1"
                                        :max="100"
                                        :interval="1"
                                        :formatter="(v) => v+'%'"
                                        :tooltip="false"
                                    >
                                        
                                    </vue-slider>
                                   <div class="columns is-mobile has-text-centered">                                    
                                        <div class="column has-text-left">0%</div>
                                        <div class="column">25%</div>
                                        <div class="column">50%</div>
                                        <div class="column">75%</div>
                                        <div class="column has-text-right">100%</div>
                                    </div>                                      
                                </div>
                            </div>
                        </div>                        
                                        
                    </div>
                </div>
                

                                        

            </div>
            <div class="section">

                <div class="animated fadeInDown content has-text-centered">
                    <h1 class="is-title is-uppercase"><span class="has-text-primary">Puissance, surface et rentabilité</span> de votre installation</h1>
                </div>
            </div>
            <div class="section">
                <div class="columns">
                    <div class="column is-7">
                        <div class="card is-fullheight animated fadeIn">
                            <header class="card-header">
                                <p class="card-header-title is-uppercase">
                                    Rentabilité de votre installation
                                </p>
                                 <b-tooltip multilined class="card-header-icon" label="La rentabilité de votre installation est liée aux paramètres précisés ci-avant ainsi, bien entendu, qu’à son prix. 
En plus de considérations esthétiques, ce dernier dépend de critères d’implantation et raccordements électriques propres à chaque installation. 
Les gains financiers ci-après établis seront donc à diminuer du coût de votre achat." position="is-left">
                                    <button class="button is-small is-light">
                                        <b-icon :icon="'question'" :size="'is-small'"/>
                                    </button>
                                </b-tooltip>
                            </header>

                            <div class="card-content">
                                <div class="content">
                                    <table class="table is-striped is-large">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <p class="is-marginless">
                                                        <small class="is-uppercase">Gain brut sur {{years}} ans</small>
                                                         <b-tooltip multilined class="card-header-icon" label="Le gain brut sur 25 ans correspond à l’économie d’électricité réalisée tenant compte de son coût d’achat et de l’inflation associée." position="is-right">
                                                            <button class="button is-small is-light">
                                                                <b-icon :icon="'question'" :size="'is-small'"/>
                                                            </button>
                                                        </b-tooltip>
                                                    </p>
                                                    <p class="is-uppercase is-size-6 has-text-grey"></p>
                                                </td>
                                                <td class="has-text-right"><strong>{{result.totals.saving}} €</strong></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="is-marginless">
                                                        <small class="is-uppercase">taxe Prosumer (à partir de 2020)</small>
                                                         <b-tooltip multilined class="card-header-icon" label="Lors de son entrée en vigueur le coût de la taxe, variable d’un gestionnaire de réseau de distribution à un autre, tournera autour de 75€/an et par kVA onduleur (1kVA = 1000W en première approche).
Ce tarif forfaitaire ou « capacitaire » pourra être réduit en augmentant votre niveau d’autoconsommation. 
Voir par ailleurs nos articles « Wallonie », « Bruxelles », « Flandres » pour en savoir plus." position="is-right">
                                                            <button class="button is-small is-light">
                                                                <b-icon :icon="'question'" :size="'is-small'"/>
                                                            </button>
                                                        </b-tooltip>
                                                    </p>
                                                    <p class="is-uppercase is-size-6 has-text-grey">Selon une autoconsommation de {{autoconsumption}}%</p>
                                                </td>
                                                <td class="has-text-right"><strong class=" has-text-success">{{result.totals.prosumer}} €</strong></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="is-marginless">
                                                        <small class="is-uppercase">gain net sur {{years}} ans</small>
                                                        <b-tooltip multilined class="card-header-icon" label="Egal à votre gain brut diminué de la taxe prosumer. " position="is-right">
                                                            <button class="button is-small is-light">
                                                                <b-icon :icon="'question'" :size="'is-small'"/>
                                                            </button>
                                                        </b-tooltip>
                                                    </p>
                                                    <p class="is-uppercase is-size-6 has-text-grey"></p>
                                                </td>
                                                <td class="has-text-right"><strong class="has-text-primary">{{result.totals.saving - result.totals.prosumer}} €</strong></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="is-marginless">
                                                        <small class="is-uppercase">productivité première année</small>
                                                        <b-tooltip multilined class="card-header-icon" label="Productivité de vos panneaux à 100% de leur performance nominale." position="is-right">
                                                            <button class="button is-small is-light">
                                                                <b-icon :icon="'question'" :size="'is-small'"/>
                                                            </button>
                                                        </b-tooltip>
                                                    </p>
                                                    <p class="is-uppercase is-size-6 has-text-grey">
                                                        Soit {{ratio}}% du rendement max (plein sud à 35° d'inclinaison)
                                                        <!-- Soit {{Math.ceil((result.years[0].production / result.totalPower) * 93)}}% du rendement max (plein sud à 35° d'inclinaison) -->
                                                    </p>
                                                </td>
                                                <td class="has-text-right"><strong>{{Math.ceil(result.years[0].production * 0.93)}} kWh/an</strong></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="is-marginless">
                                                        <small class="is-uppercase">productivité résiduelle minimum après {{years}} ans</small>
                                                        <b-tooltip multilined class="card-header-icon" label="La productivité résiduelle de vos panneaux est de minimum 82% de leur valeur « An 1 ». Fonction de la technologie choisie, elle peut être supérieure." position="is-right">
                                                            <button class="button is-small is-light">
                                                                <b-icon :icon="'question'" :size="'is-small'"/>
                                                            </button>
                                                        </b-tooltip>
                                                    </p>
                                                    <p class="is-uppercase is-size-6 has-text-grey">
                                                        Soit 82% de la valeur an 1
                                                        <!-- Soit {{Math.ceil((result.years[years - 1].production / result.years[0].production) * 93)}}% de la valeur première année                                                         -->
                                                    </p>
                                                </td>
                                                <td class="has-text-right"><strong>{{result.years[years - 1].production}} kWh/an</strong></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="is-marginless">
                                                        <small class="is-uppercase">production minimum d'électricité sur {{years}} ans</small>
                                                        <b-tooltip multilined class="card-header-icon" label="Somme de la productivité de chaque année tenant compte de la décroissance progressive maximum." position="is-right">
                                                            <button class="button is-small is-light">
                                                                <b-icon :icon="'question'" :size="'is-small'"/>
                                                            </button>
                                                        </b-tooltip>
                                                    </p>
                                                    <p class="is-uppercase is-size-6 has-text-grey"></p>
                                                </td>
                                                <td class="has-text-right"><strong class="has-text-primary">{{result.totals.production}} kWh</strong></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="is-marginless">
                                                        <small class="is-uppercase">économie de CO<sup>2</sup> sur {{years}} ans</small>
                                                        <b-tooltip multilined class="card-header-icon" label="1kWh photovoltaïque évite la production de 456 grammes de CO2. " position="is-right">
                                                            <button class="button is-small is-light">
                                                                <b-icon :icon="'question'" :size="'is-small'"/>
                                                            </button>
                                                        </b-tooltip>
                                                    </p>
                                                    <p class="is-uppercase is-size-6 has-text-grey"></p>
                                                </td>
                                                <td class="has-text-right"><strong class="has-text-success">{{result.totals.savingCo | one_digit}} T de CO<sup>2</sup></strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>        
                            </div>
                        </div>                          
                    </div>
                    <div class="column is-5">
                        <div class="card animated fadeIn">
                            <header class="card-header">
                                <p class="card-header-title is-uppercase">
                                    Puissance de votre installation
                                </p>
                                 <b-tooltip multilined class="card-header-icon" label="Donnée par la puissance de vos modules multiplié par leur nombre." position="is-left">
                                    <button class="button is-small is-light">
                                        <b-icon :icon="'question'" :size="'is-small'"/>
                                    </button>
                                </b-tooltip>
                            </header>
                            <div class="card-content">
                                <div class="content">
                                     <h2 class="is-title has-text-primary has-text-centered">
                                        {{result.totalPower}} Wc
                                    </h2>

                                    <div class="columns">
                                        <div class="column is-1"
                                            v-for="i in 12"
                                            :style="{
                                                position: 'relative',
                                                overflow: 'hidden',
                                                height: 200+'px',
                                            }"
                                        >
                                            <div class="animated bounceInUp" 
                                            
                                            :style="{
                                                display:'flex',
                                                alignItems: 'bottom',
                                                justifyContent: 'bottom',
                                                textAlign: 'center',
                                                borderRadius: '3px 3px 0 0 ',
                                                animationDelay: i * 100 + 'ms',
                                                height: 50 + (i * (100 / 12))+'px',
                                                width: 80+'%',
                                                paddingLeft: 10+'%',
                                                paddingRight: 10+'%',
                                                position: 'absolute',
                                                bottom: 0,
                                                background: result.power >= (i * 1000) ? '#3E87CB' : 'whitesmoke',
                                            }">
                                                <strong :style="{
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    width: 80+'%',
                                                    textAlign: 'center'
                                                }">{{i}}k</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>   
                        
                        <div class="card animated fadeIn">
                            <header class="card-header">
                                <p class="card-header-title is-uppercase">
                                    Occupation de surface
                                </p>
                                 <b-tooltip multilined class="card-header-icon" label="Surface d’un panneau multiplié par le nombre de panneaux de votre installation." position="is-left">
                                    <button class="button is-small is-light">
                                        <b-icon :icon="'question'" :size="'is-small'"/>
                                    </button>
                                </b-tooltip>
                            </header>
                            <div class="card-content">
                                <div class="content has-text-centered">
                                    <div class="columns is-mobile" v-if="results.length">
                                        <div class="column is-5">
                                            <h2 class="is-title has-text-primary">
                                                {{result.number}}
                                            </h2>
                                            <p class="is-uppercase">{{result.panel.brand}} <br> ({{result.panel.model}} - {{result.panel.nominalPower}}Wc)</p>
                                            <h2 class="is-title has-text-primary">
                                                {{result.area | one_digit}} m<sup>2</sup>
                                            </h2>                                            
                                        </div>
                                        <div class="column is-2">
                                            <h2 class="is-flex has-text-centered is-title is-1" :style="{alignItems: 'center',height:'100%'}">
                                                <strong>OU</strong>
                                            </h2>
                                        </div>
                                        <div class="column is-5">
                                            <h2 class="is-title has-text-primary">
                                                {{results[1].number}}
                                            </h2>
                                            <p class="is-uppercase">{{results[1].panel.brand}} <br> ({{results[1].panel.model}} - {{results[1].panel.nominalPower}}Wc)</p>
                                            <h2 class="is-title has-text-primary">
                                                {{results[1].area | one_digit}} m<sup>2</sup>
                                            </h2>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
            </div>
            <div class="section">

                <div class="animated fadeInDown content has-text-centered">
                    <h1 class="is-title is-uppercase">Répartition de votre <span class="has-text-primary">production annuelle</span></h1>
                </div>
            </div>
            <div class="section">
                <div class="card animated fadeIn">
                    <header class="card-header">
                        <p class="card-header-title is-uppercase">
                            Répartition de votre production annuelle
                        </p>
                         <b-tooltip multilined class="card-header-icon" label="Le graphe affiche, à titre indicatif, la distribution statistique moyenne de l’ensoleillement en Belgique." position="is-left">
                            <button class="button is-small is-light">
                                <b-icon :icon="'question'" :size="'is-small'"/>
                            </button>
                        </b-tooltip>
                    </header>                    
                    <div class="card-content">
                        <div class="content">
                            <Chart
                                :chartData="chartData"
                                :options="{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    legend: {
                                        display: false
                                    },
                                    tooltips: {
                                        enabled: true,
                                        mode: 'single',
                                        callbacks: {
                                            label: function(tooltipItems, data) { 
                                                return tooltipItems.yLabel + ' kWh/mois';
                                            }
                                        }                                        
                                    },
                                      scales: {
                                        yAxes: [{
                                          gridLines: {
                                            drawBorder: false,
                                          },
                                        }],
                                        xAxes: [{
                                          gridLines: {
                                            display: false,
                                          },
                                        }],                                        
                                      },
                                }"
                                :height="400">
                                  
                            </Chart>
                        </div>
                    </div>
                </div>                  
            </div>       
        </div>  
        <footer class="footer">
            <div class="content has-text-centered">
                <p>
                    Copyright Gramme 2018
                </p>
                <p>
                    All right reserved
                </p>
            </div>
        </footer>
    </div>
</div>
</template>

<script>
    import style from './style.scss'
    import animate from 'animate.css'
    import vueSlider from 'vue-slider-component'
    import Chart from './Chart.vue'

    export default {
        name: 'app',
        components:{
            vueSlider,
            Chart,
        },
        data()
        {
            return {
                ratio: 0,
                unkownConsumtion: false,
                years: 25,
                consumption: 4000,
                orientation: 135,
                autoconsumption: 37,
                tilt: 50,
                height: 4,
                roof: 0,
                age: 0,
                postalCode: 1000,
                electricityPrice: 0.25,
                inflation: 3,
                ages : [
                'Moins de 10 ans',
                'Plus de 10 ans',
                ],
                vats: [
                6,
                10
                ],
                lf: 0.106, 
                grds: [],      
                roofs : [
                {name:'Toiture inclinée',icon:'/img/ToitureInclinee.svg'},
                {name:'Tracker',icon:'/img/Tracker.svg'},
                {name:'Sol ou façade',icon:'/img/SolOuFacade.svg'},
                {name:'Toiture plate',icon:'/img/ToiturePlate.svg'},
                ],
                orientations: [90,135,180,225,270],
                tilts: [0,15,25,35,50,70,90],
                steps:[
                [88,87,85,83,77,65,50],
                [88,93,95,95,92,81,64],
                [88,96,99,100,98,87,68],
                [88,93,95,95,92,81,64],
                [88,87,85,82,76,65,50],
                ],
                consumptions:[
                2000,
                3200,
                3700,
                4500,
                5500,
                5700,
                6500,
                7500,
                ],
                panels: [
                {
                    type: 'Polycristallins',
                    name: 'Panneaux Polycristallins',
                    brand: 'Trina_Solar',
                    model: 'TSM-270 PC05A',
                    nominalPower: 270,
                    width: 1670,
                    height: 1012,
                    pitch: 20,
  maxYield: 0.97,//2 years
  minYield: 0.82,// 25years
},
{
    type: 'Monocristallins',
    name: 'Panneaux Monocristallins "Full Black"',
    brand: 'LG',
    model: 'LG NEON-320N1K-A5',
    nominalPower: 320,
    width: 1706,
    height: 1036,
    pitch: 20,
  maxYield: 0.97,//2 years
  minYield: 0.82,// 25years
},
{
    type: 'Monocristallins',
    name: 'Panneaux Monocristallins haut rendement',
    brand: 'AUO-BenQ',
    model: 'PM096B00-335',
    nominalPower: 335,
    width: 1579,
    height: 1066,
    pitch: 20,
  maxYield: 0.95,//2 years
  minYield: 0.87,// 25years
},
{
    type: 'Polycristallins',
    name: 'Panneaux Polycristallins + Structure de pose toiture plate (Sunbeam)',
    brand: 'Trina_Solar',
    model: 'TSM-270 PC05A',
    nominalPower: 270,
    width: 1670,
    height: 1700,
    pitch: 20,
  maxYield: 0.97,//2 years
  minYield: 0.82,// 25years
},        
]

  }
},
computed:
{
    chartData()
    {
        var average = 70.4

        var monthlyRatios = [23,48,66,93,110,102,115,103,78,57,33,18]
        var data = []

        monthlyRatios.forEach((r) => {
            data.push(Math.round(this.result.annualProduction / 12 * (r / 70.4)))
        })
        return {
          labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
          datasets: [
            {
              backgroundColor: '#3E87CB',
              data: data,
            }
          ]
        }
    },
    results()
    {
        // return []
        return [
            this.calculate(0),
            this.calculate(1),
        ]
    },
    result()
    {
        return this.calculate(0);
    },
    vat()
    {
        return this.vats[this.age];
    },
    grd()
    {
        return this.grds.find((item) => item.postalCode == this.postalCode)
    },
},
mounted()
{
    this.getGrds();
},
methods:
{

    calculate(index)
    {

      let panel = this.panels[index];
      
      switch(this.roof)
      {
          case 1:
              this.orientation = 180;
              this.tilt = 35;
          break;
          case 2:
              this.tilt = 35;
          break;
          case 3:
              this.tilt = 15;
          break;
      }
      
      let tilt = index == 3 ? 0 : this.tilt; // Si le toit est plat

      let indexOrientation = this.orientations.indexOf(this.orientation);
      let indexTilt = this.tilts.indexOf(tilt);
      this.ratio = this.steps[indexOrientation][indexTilt];
      let power = Math.round((this.consumption * 1000) / (365 * 24 * this.lf * this.ratio / 100));            
      let minPower = power < 10000 ? power : 10000;
      let number = Math.floor((minPower / panel.nominalPower) + 1);
      let totalPower = Math.round(number * panel.nominalPower);
      let area = ((panel.width * panel.height) /1000000) * number;
      let annualProduction = Math.round(totalPower * 365 * 24 * this.lf * this.ratio / 100 / 1000);

      let years = [];

      

      let totals = {
          prosumer: 0,
          production: 0,
          saving: 0,
          price: 0,
      };

      for(let i = 0; i < 25; i++)
      {
          let lastYear = years[i - 1];
          let production
          let saving
          let price = lastYear ? (lastYear.price + (lastYear.price * (this.inflation / 100)) ) : this.electricityPrice;
          let prosumer = 0
          
          if(i <= 1)
          {
              production = lastYear ? (annualProduction * panel.maxYield) : annualProduction;
              saving = production * price;
              
          }
          else
          {
              production = (years[1].production - ((i / 24) * (1 - (panel.minYield)) * lastYear.production));
              saving = production * price;
              prosumer = (production * (1 - (this.autoconsumption / 100) )) * ( 0.11+(0.11 * (this.inflation / 100)))              
          }


          
          years[i] = {          
              year: (i + 1),
              production: Math.floor(production),
              prosumer: Math.ceil(prosumer),
              price: price,
              saving: saving,
          };


          totals.prosumer += Math.round(prosumer);
          totals.production += Math.round(production);
          totals.saving += Math.round(saving);
          totals.price += price;
          totals.savingCo = 456 * totals.production / 1000000
      }
      
      console.table(years)

      totals.price = Math.ceil(totals.price / 25 * 100) / 100;

      if(this.grd && this.grd.name == 'SIBELGA')
      {
       
          totals.saving += ((power > 5000) ? 2.4 : 3) * 85 * 10 * years[1].production / 1000
          
      }
      return {
          panel : panel,        
          area : area,        
          minPower : minPower,
          number : number,
          power: power,
          totalPower: totalPower,
          annualProduction: annualProduction,
          years: years,
          totals: totals,

      }
  },
  getGrds()
  {
      return this.$http.get('grds.json').then((response) => {

          if(response.ok)
          {
              this.grds = response.body;
          }
      }).catch(() => {

      });
  }
},
filters: {
    'one_digit': (value) => {
        return Number(Math.round(value+'e1')+'e-1');
    },
    'two_digits': (value) => {
        return Number(Math.round(value+'e2')+'e-2');
    }
}  
}
</script>